export type BackgroundImageGeometry = { x: number; y: number; width: number; height: number };

export function getBackgroundImageGeometry(
  canvasWidth: number,
  canvasHeight: number,
  imageWidth: number,
  imageHeight: number,
  offsetX: number,
  offsetY: number,
): BackgroundImageGeometry {
  const scale = Math.max(canvasWidth / imageWidth, canvasHeight / imageHeight);
  const width = imageWidth * scale;
  const height = imageHeight * scale;
  return {
    x: (canvasWidth - width) * (offsetX + 100) / 200,
    y: (canvasHeight - height) * (offsetY + 100) / 200,
    width,
    height,
  };
}
